import { LoaderFunctionArgs } from 'react-router';

import { TCustomRouteObject } from '@/shared/types/router.types';
import { OpenPlcOrchestratorFragment } from '@/shared/types/types.generated';

export const orchestratorsRoutes: TCustomRouteObject = {
  path: '/orchestrators',
  // Lazy so the provisioning subscription and its api slice stay out of the
  // entry chunk for a session that never opens this page.
  lazy: async () => {
    const { OrchestratorsLayout } = await import('./orchestrators-layout');
    return { Component: OrchestratorsLayout };
  },
  handle: {
    crumb: {
      label: 'orchestrators',
      localized: true,
    },
  },
  children: [
    {
      index: true,
      lazy: async () => {
        const { OrchestratorsRoute } = await import('./orchestrators');
        return { Component: OrchestratorsRoute };
      },
    },
    {
      path: ':orchestratorId/:tabId?',
      lazy: async () => {
        const { OrchestratorVplcsPage } = await import('./orchestrator-vplcs');
        return { Component: OrchestratorVplcsPage };
      },
      // Switching tab is a navigation, and the loader only feeds the breadcrumb.
      shouldRevalidate: () => false,
      loader: async (args: LoaderFunctionArgs) => {
        const { orchestratorVplcsLoader } =
          await import('./orchestrator-vplcs');
        return orchestratorVplcsLoader(args);
      },
      handle: {
        crumb: {
          label: (data: OpenPlcOrchestratorFragment | null) => data?.name,
        },
      },
    },
  ],
};
